import React from "react";
import { Heading, HStack, Image, Text } from "@chakra-ui/react";
import packageInfo from "../../../../package.json";

function HeaderLeft() {
  return (
    <HStack userSelect={"none"} position={"absolute"} top={2} left={2} zIndex={1001}>
      <HStack gap={2} rounded="lg" boxShadow="lg" bg={"Background"} p={1}>
        <Image src="./assets/image/gatik-logo.png" aspectRatio={1 / 1} width="50px" />
        <Heading size={"3xl"}>Gatik Horizon</Heading>
        <Text textStyle={"xs"} alignSelf={"start"}>
          V {packageInfo.version}
        </Text>
      </HStack>
    </HStack>
  );
}

export default HeaderLeft;
